import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { api } from "../../lib/api";

// Carte « Rabais de bienvenue » de l'onglet Clients (demande du propriétaire,
// 2026-10-23) : combien de WELCOME10 ont été OFFERTS ce mois-ci (boutique +
// fiches) et combien ont été UTILISÉS (payés).
export function CompteurBienvenue() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/admin/stats/bienvenue-mois").then((r) => setStats(r.data)).catch(() => {});
  }, []);
  if (!stats) return null;
  const mois = new Date(stats.mois + "-15T12:00:00").toLocaleDateString("fr-CA", { month: "long", year: "numeric" });
  return (
    <div className="mb-5 rounded-lg border border-gold/20 bg-gold/[0.04] px-4 py-3 flex flex-wrap items-center gap-x-4 gap-y-1"
      data-testid="compteur-bienvenue">
      <p className="text-[11px] uppercase tracking-widest text-gold flex items-center gap-1.5">
        <Gift className="w-3.5 h-3.5" /> Rabais de bienvenue — {mois}
      </p>
      <p className="text-xs text-ivory/75" data-testid="compteur-bienvenue-offerts">
        <strong className="text-champagne">{stats.offerts}</strong> offert{stats.offerts > 1 ? "s" : ""}
        <span className="text-ivory/50"> ({stats.offerts_boutique} boutique · {stats.offerts_fiches} fiche{stats.offerts_fiches > 1 ? "s" : ""})</span>
      </p>
      <p className="text-xs text-ivory/75" data-testid="compteur-bienvenue-utilises">
        <strong className="text-emerald-300">{stats.utilises}</strong> utilisé{stats.utilises > 1 ? "s" : ""} (payé{stats.utilises > 1 ? "s" : ""})
      </p>
    </div>
  );
}
